export default __webpack_public_path__ + "static/media/process.c21b7947.jpeg";